import { createSelector } from 'reselect';
import { showSelector } from 'selectors/testTarget/offers/freeReturnsOnBasket/show/showSelector';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';

const showFreeReturnsOnBasketSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showFreeReturnsOnBasketSelector };
